import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ServerInfosService } from '../../remote-services/server-infos.service'
import { forkJoin, Observable } from 'rxjs'
import { MatDialogRef } from '@angular/material/dialog'
import { ServerInfosDto } from '../../remote-services/dtos/serverInfos.dto'

@Component({
  selector: 'server-info-dialog-container',
  template: `
    <server-info-dialog
      [serverInfos]="serverInfos$ | async"
      (closeEvent)="onClose()"
    ></server-info-dialog>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ServerInfoDialogContainerComponent {
  private serverInfosService = inject(ServerInfosService)
  private dialogRef =
    inject<MatDialogRef<ServerInfoDialogContainerComponent>>(MatDialogRef)

  serverInfos$: Observable<ServerInfosDto[]> = forkJoin([
    this.serverInfosService.getServerEquipmentInfo(),
    this.serverInfosService.getServerExportInfo(),
    this.serverInfosService.getServerGraphInfo(),
    this.serverInfosService.getServerJobsiteInfo(),
    this.serverInfosService.getServerPreparationInfo(),
    this.serverInfosService.getServerRestPilesInfo(),
    this.serverInfosService.getServerRestHFInfo(),
    this.serverInfosService.getServerSoillibInfo(),
    this.serverInfosService.getServerUserInfo(),
  ])

  onClose(): void {
    this.dialogRef.close()
  }
}
